module.exports = __webpack_public_path__ + "img/banner.e257f312.png";